export const defaultMemberInfo = {
  currentWorkStatus: {
    value: '',
    other: '',
  },
  contributionPlans: {
    value: '',
    other: '',
  },
  incomeNeeds: {
    value: '',
    other: '',
  },
  longTermIncomeNeeds: {
    value: '',
    other: '',
  },
  riskAppetite: {
    value: '',
    other: '',
  },
};

const defaultInvStrat = {
  members: [],
  memberInfo: null,
  selection: '',
  objective: {
    percent: 0,
    years: 0,
    statement() {
      return `The trustee will seek to achieve investment returns that exceed inflation by at least ${this.percent}% pa before taxes and expenses over rolling ${this.years} year periods.`;
    },
  },
  assets: [],
  borrowing: false,
  diversified: {
    diversified: 'no',
    assets: [],
  },
  insurance: {
    policies: '',
    purpose: [],
    other: '',
  },
};

export default defaultInvStrat;
